import styled from "styled-components";
import { BRAND, GRAY_LIGHT } from "@streeteasy/design-system/colors";
import {
  SecondaryLarge,
  SecondaryMedium
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 -12px;
  padding: 29px 0;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: column;
    margin: 0;
  }
`;

export const Card = styled.div`
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  margin: 12px;
  max-width: 420px;
  min-height: 365px;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    max-width: 420px;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Content = styled.div`
  padding: 23px 30px;
`;

export const Link = styled.a`
  bottom: 0;
  font-size: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const Title = styled(SecondaryLarge).attrs({
  as: "h3"
})`
  color: ${BRAND};
  margin: 0 0 16px;
`;

export const Image = styled.img`
  border-bottom: 1px solid ${GRAY_LIGHT};
  display: block;
  height: 209px;
  object-fit: cover;
  width: 100%;
`;

export const Description = styled(SecondaryMedium).attrs({ as: "h4" })``;
